export const LOCAL_STORAGE_RAF_POPUP_COUNTER = 'close_game_popup_raf_counter';
export const CLOSE_GAME_RAF_POPUP_LIMIT = 2;

export const LOCAL_STORAGE_PROMO_POPUP_COUNTER = 'close_game_popup_promo_counter';
export const CLOSE_GAME_PROMO_POPUP_LIMIT = 2;
